module.exports = __webpack_public_path__ + "static/media/1004985.f507d2fb.png";